import * as angular from "angular";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";

export class ExpensesAlerts {

  constructor(private bringozToastService: BringozToastService) {
  }

  getOneError() {
    const message = {
      body: 'EXPENSES_GET_ONE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  getExpenseTimeLineError() {
    const message = {
      body: 'EXPENSES_GET_TIME_LINE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  getMultipleError() {
    const message = {
      body: 'EXPENSES_GET_MANY_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  expensesCategoryArchiveSuccess() {
    const message = {
      body: 'EXPENSES_CATEGORY_ARCHIVE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  expensesCategoryArchiveError() {
    const message = {
      body: 'EXPENSES_CATEGORY_ARCHIVE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  expensesCategoryCreateSuccess() {
    const message = {
      body: 'EXPENSES_CATEGORY_CREATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  expensesCategoryCreateError() {
    const message = {
      body: 'EXPENSES_CATEGORY_CREATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  expensesCategoryEditSuccess() {
    const message = {
      body: 'EXPENSES_CATEGORY_EDIT_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  expensesCategoryEditError() {
    const message = {
      body: 'EXPENSES_CATEGORY_EDIT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }


  expensesCreateSuccess() {
    const message = {
      body: 'EXPENSES_CREATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  expensesCreateError() {
    const message = {
      body: 'EXPENSES_CREATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  expensesEditSuccess() {
    const message = {
      body: 'EXPENSES_EDIT_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  expensesEditError() {
    const message = {
      body: 'EXPENSES_EDIT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  approveExpensesSuccess() {
    const message = {
      body: 'EXPENSES_APPROVE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  approveExpensesError() {
    const message = {
      body: 'EXPENSES_APPROVE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  declineExpensesSuccess() {
    const message = {
      body: 'EXPENSES_DECLINE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  declineExpensesError() {
    const message = {
      body: 'EXPENSES_DECLINE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  deleteExpensesSuccess() {
    const message = {
      body: 'EXPENSES_DELETE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  deleteExpensesError() {
    const message = {
      body: 'EXPENSES_DELETE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  exportExpensesSuccess() {
    const message = {
      body: 'EXPENSES_EXPORT_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  exportExpensesError() {
    const message = {
      body: 'EXPENSES_EXPORT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }


}
angular
  .module('bringoz.admin.expenses')
  .service('expensesAlerts', ExpensesAlerts);
